import React from 'react';
import { Box } from '@storyofams/react-ui';

import { Modal } from '~components';
import { RichText } from '~components/common/RichText';
import { ThemeboxmealItem } from '~lib/storyblok/sdk';

interface DetailModal {
  open: boolean;
  toggleOpen: (open: boolean) => void;
  content: ThemeboxmealItem['content']['details'];
  title?: string;
}

export const DetailModal = ({ open, toggleOpen, title, content }) => {
  return (
    <Modal isOpen={open} close={() => toggleOpen(false)} title={title}>
      <Box width="100%" overflowY="auto">
        <RichText text={content} />
      </Box>
    </Modal>
  );
};

export default DetailModal;
